import { createApp } from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import axios from './axios/axios'
import router from './router/router'
import Toaster from '@meforma/vue-toaster'
import store from './store/store'
import moment from 'moment'

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fas, faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { fab, faFacebook, faGooglePlus } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import "./assets/css/style.css"
import "./assets/css/timecard.scss"

import jQuery from 'jquery'
window.$ = window.jQuery = jQuery
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'admin-lte/dist/js/adminlte.min.js'
import 'select2'

import 'admin-lte/dist/css/adminlte.min.css'
import 'select2/dist/css/select2.min.css'
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css'
import 'toastr/build/toastr.min.css'

import { checkAndSetAuthFromCookie } from './utils/cookieUtils'

library.add(fas, fab, far, faLock, faEnvelope, faFacebook, faGooglePlus)
dom.watch()

const app = createApp(App)
app.config.globalProperties.$http = axios
app.config.globalProperties.$moment = moment

const options = {
  position: 'top',
  duration: 2000,
  max: 0,
}

checkAndSetAuthFromCookie()

app.component("font-awesome-icon", FontAwesomeIcon)
app.use(Toaster, options)
app.use(store)
app.use(router)
app.use(Vuelidate)
app.mount('#app')
